/**
 * @generated SignedSource<<4ecf54a7ed6460a33b272429e2517930>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChecklistToolCallResult_toolCall$data = {
  readonly toolResult: {
    readonly content: string;
    readonly llmConversation: {
      readonly id: any;
    } | null | undefined;
    readonly sources: ReadonlyArray<{
      readonly artifactId: string | null | undefined;
      readonly description: string | null | undefined;
      readonly displayText: string;
      readonly groupTags: ReadonlyArray<string> | null | undefined;
      readonly link: string | null | undefined;
      readonly query: any | null | undefined;
      readonly title: string | null | undefined;
      readonly toolId: string | null | undefined;
      readonly type: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
  readonly toolUse: {
    readonly displayName: string | null | undefined;
    readonly input: {
      readonly __typename: "BuildkiteAnnotationsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "BuildkiteArtifactsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "BuildkiteBuildsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "BuildkiteFlakyTestToolInput";
      readonly question: string;
    } | {
      readonly __typename: "BuildkiteLogsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "CloudWatchLogsAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "CloudWatchLogsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "CloudWatchMetricsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogCIPipelineEventsAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogCIPipelineEventsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogErrorTrackingIssueDetailsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogErrorTrackingIssuesToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogEventsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogLogsAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogLogsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogMetricsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogMonitorToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogRumAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogServiceDependencyToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogSpansAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "DatadogSpansToolInput";
      readonly question: string;
    } | {
      readonly __typename: "GenericToolInput";
      readonly rawInput: any;
    } | {
      readonly __typename: "GitHubActionsLogsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "GitHubActionsRunsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicLogsAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicLogsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicMetricsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicSpansAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicSpansToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicTransactionsAggregationToolInput";
      readonly question: string;
    } | {
      readonly __typename: "NewRelicTransactionsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "QueryCodeToolInput";
      readonly question: string;
    } | {
      readonly __typename: "SlackChannelContentsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "SlackChannelMetadataToolInput";
      readonly question: string;
    } | {
      readonly __typename: "SlackUsergroupMentionToolInput";
      readonly usergroupHandle: string;
    } | {
      readonly __typename: "TemporalWorkflowHistoryToolInput";
      readonly question: string;
    } | {
      readonly __typename: "TemporalWorkflowsToolInput";
      readonly question: string;
    } | {
      readonly __typename: "UpdateTodoToolInput";
      readonly tasks: ReadonlyArray<any>;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentType": "ChecklistToolCallResult_toolCall";
};
export type ChecklistToolCallResult_toolCall$key = {
  readonly " $data"?: ChecklistToolCallResult_toolCall$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChecklistToolCallResult_toolCall">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "question",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChecklistToolCallResult_toolCall",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageToolUse",
      "kind": "LinkedField",
      "name": "toolUse",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "input",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "DatadogLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "DatadogLogsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "DatadogMetricsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "DatadogSpansToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "DatadogSpansAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "DatadogRumAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "DatadogEventsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "DatadogCIPipelineEventsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "DatadogCIPipelineEventsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "DatadogMonitorToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "DatadogServiceDependencyToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "DatadogErrorTrackingIssueDetailsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "DatadogErrorTrackingIssuesToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "BuildkiteBuildsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "BuildkiteLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "BuildkiteAnnotationsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "BuildkiteArtifactsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "BuildkiteFlakyTestToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "CloudWatchLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "CloudWatchLogsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "CloudWatchMetricsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "NewRelicLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "NewRelicLogsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "NewRelicMetricsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "NewRelicSpansToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "NewRelicSpansAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "NewRelicTransactionsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "NewRelicTransactionsAggregationToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "QueryCodeToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "GitHubActionsRunsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "GitHubActionsLogsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "SlackChannelContentsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "SlackChannelMetadataToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "usergroupHandle",
                  "storageKey": null
                }
              ],
              "type": "SlackUsergroupMentionToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "TemporalWorkflowsToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "TemporalWorkflowHistoryToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tasks",
                  "storageKey": null
                }
              ],
              "type": "UpdateTodoToolInput",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rawInput",
                  "storageKey": null
                }
              ],
              "type": "GenericToolInput",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageToolResult",
      "kind": "LinkedField",
      "name": "toolResult",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLIntegrationQuerySource",
          "kind": "LinkedField",
          "name": "sources",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "toolId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "artifactId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "groupTags",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "query",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "link",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLLlmConversation",
          "kind": "LinkedField",
          "name": "llmConversation",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLMessageToolCall",
  "abstractKey": null
};
})();

(node as any).hash = "027add0bfe41c28e3438a7e614c55644";

export default node;
